module.exports = __webpack_public_path__ + "img/74.1.3c018d90.jpg";